<template>
  <section class="main-banner__wrapper">
    <su-attestat-modal
      v-if="showAttestatModal"
      @close="showAttestatModal = false"
    />

    <div
      :class="['main-banner', {
        'main-banner-5-7': external5,
        'main-banner-8-9': external8,
        'main-banner-10-11': external10,
      }]"
    >
      <h1 class="main-banner__title">
        школа экстернат {{ classesByPage }}&nbsp;класс
      </h1>
      <h2 class="main-banner__subtitle">
        <span>
          закончите школу быстрее и посвятите год важному — подготовке
          к&nbsp;егэ и поступлению в вуз мечты, карьере или своим увлечениям!
        </span>
        познакомьтесь с&nbsp;платформой и&nbsp;преподавателями
      </h2>

      <button
        class="main-banner__btn m-btn"
        @click="openModal(MODAL_TYPES.demo)"
      >
        получить доступ
      </button>

      <span class="main-banner__cheap">
        7 дней бесплатно
      </span>

      <button
        class="m-btn main-banner__to-down"
        @click="scrollTo('.external-choose')"
      >
        <img
          src="/v2/catalog/repetitor/banner/arrow-down.svg"
          alt="down"
        >
      </button>
    </div>

    <school-new-banner-blocks2 graduates-block />
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import scrollTo from '~/utils/scrollTo';
import { MODAL_TYPES } from '../common/AppHeader/data';

import SchoolNewBannerBlocks2 from '../school-new/SchoolNewBannerBlocks2.vue';
import SuAttestatModal from '../school-university/SuAttestatModal.vue';

export default {
  name: 'ExternalNewBanner',
  components: {
    SuAttestatModal,
    SchoolNewBannerBlocks2,
  },
  data: () => ({
    showAttestatModal: false,
    MODAL_TYPES,
    scrollTo,
  }),
  computed: {
    external5() {
      return this.$route.name === 'externat-5-7klass';
    },
    external8() {
      return this.$route.name === 'externat-8-9klass';
    },
    external10() {
      return this.$route.name === 'externat-10-11klass';
    },

    classesByPage() {
      if (this.external5) {
        return '5-7';
      }

      if (this.external8) {
        return '8-9';
      }

      if (this.external10) {
        return '10-11';
      }

      return '5-11';
    },
  },
  methods: {
    ...mapActions('appHeaderModals', {
      openModal: 'openModal',
    }),
  },
};
</script>

<style lang="scss" scoped>

.main-banner {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: calc(var(--scale) * 512);
  padding: calc(var(--scale) * 32) calc(var(--scale) * 40) calc(var(--scale) * 40);
  border-radius: calc(var(--scale) * 60);

  background-image: url("/v2/external-new/banner/bg.webp");
  background-size: cover;
  background-position: right bottom;

  @include media-down($size-tablet) {
    height: calc(var(--scale) * 400);
    padding: calc(var(--scale) * 16) calc(var(--scale) * 8) calc(var(--scale) * 8);
    border-radius: calc(var(--scale) * 32);
    background-image: url("/v2/external-new/banner/bg-tablet.webp");
  }

  @include media-down($size-mobile) {
    height: calc(var(--scale) * 560);
    background-image: url("/v2/external-new/banner/bg-mob.webp");
    background-position: center;
  }

  &__title  {
    max-width: calc(var(--scale) * 1025);
    margin-bottom: calc(var(--scale) * 20);

    text-indent: calc(var(--scale) * 8);
    margin-left: calc(-1 * var(--scale) * 8);

    font-family: 'Onest', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: calc(var(--scale) * 120);
    line-height: 80%;
    letter-spacing: -0.06em;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      max-width: calc(var(--scale) * 334);
      margin-bottom: calc(var(--scale) * 8);
      padding-inline: calc(var(--scale) * 8);
      text-indent: calc(var(--scale) * 2);
      margin-left: calc(-1 * var(--scale) * 2);
      font-size: calc(var(--scale) * 54);
      letter-spacing: -0.02em;
      line-height: 90%;
    }
  }

  &__subtitle {
    max-width: calc(var(--scale) * 869);

    font-family: 'Onest', sans-serif;
    font-weight: 500;
    font-size: calc(var(--scale) * 26);
    line-height: 110%;
    color: #FFFFFF;

    span {
      opacity: 0.6;
    }

    @include media-down($size-tablet) {
      max-width: calc(var(--scale) * 334);
      padding-inline: calc(var(--scale) * 8);
      font-size: calc(var(--scale) * 16);
      letter-spacing: -0.02em;
    }
  }

  &__btn {
    margin-top: auto;
    padding: calc(var(--scale) * 32) calc(var(--scale) * 56);
    background-color: #FF5319;
    border-radius: calc(var(--scale) * 32);
    transition: 200ms;

    font-family: 'Onest', sans-serif;
    font-weight: 500;
    font-size: calc(var(--scale) * 26);
    line-height: 120%;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      padding: calc(var(--scale) * 30);
      width: 100%;
      border-radius: calc(var(--scale) * 24);
      font-size: calc(var(--scale) * 18);
    }

    @media (hover: hover) {
      &:hover {
        background-color: #FF9C12;
      }
    }
  }

  &__cheap {
    position: absolute;
    left: calc(var(--scale) * 214);
    bottom: calc(var(--scale) * 20);

    padding: calc(var(--scale) * 8) calc(var(--scale) * 16) calc(var(--scale) * 10);
    background-color: #FFFFFF;
    border-radius: calc(var(--scale) * 40);
    transform: rotate(-5deg);

    font-weight: 500;
    font-size: calc(var(--scale) * 16);
    line-height: 130%;
    color: #FF5319;

    @include media-down($size-tablet) {
      left: auto;
      right: calc(var(--scale) * 7);
      bottom: calc(var(--scale) * 77);
      transform: rotate(5deg);
      padding: calc(var(--scale) * 4) calc(var(--scale) * 10) calc(var(--scale) * 6);
      font-size: calc(var(--scale) * 14);
    }
  }

  &__to-down {
    width: calc(var(--scale) * 64);
    height: calc(var(--scale) * 64);
    outline: none;

    position: absolute;
    z-index: 2;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 50%);

    background-color: $white-color;
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 50%;

    img {
      filter: invert(18%) sepia(52%) saturate(6003%) hue-rotate(248deg) brightness(92%) contrast(95%);
    }

    @include media-down($size-tablet) {
      display: none;
    }
  }

  &.main-banner-5-7 {
    background-image: url("/v2/external-new/banner/bg-5.webp");

    @include media-down($size-tablet) {
      background-image: url("/v2/external-new/banner/bg-tablet-5.webp");
    }

    @include media-down($size-mobile) {
      background-image: url("/v2/external-new/banner/bg-mob-5.webp");
    }
  }

  &.main-banner-8-9 {
    background-image: url("/v2/external-new/banner/bg-8.webp");

    @include media-down($size-tablet) {
      background-image: url("/v2/external-new/banner/bg-tablet-8.webp");
    }

    @include media-down($size-mobile) {
      background-image: url("/v2/external-new/banner/bg-mob-8.webp");
    }
  }

  &.main-banner-10-11 {
    background-image: url("/v2/external-new/banner/bg-10.webp");

    @include media-down($size-tablet) {
      background-image: url("/v2/external-new/banner/bg-tablet-10.webp");
    }

    @include media-down($size-mobile) {
      background-image: url("/v2/external-new/banner/bg-mob-10.webp");
    }
  }
}

</style>
